import { z } from "zod";
import {
  CompanyRemunerationReferenceContextSchema,
  CompanyRemunerationReferenceDataSchema,
  CompanyRemunerationReferenceExtractionSchema,
  type CompanyRemunerationReferenceData,
} from "../../../document/document-types/company-remuneration-reference";
import type { FieldMessages } from "../../../document/types";
import { createFieldMessagesSchema } from "../../../document/schema";
import { storeResponseSchema } from "../base";
import type { DocumentTypeSchemas } from "../types";

const fieldMessagesSchema = createFieldMessagesSchema(CompanyRemunerationReferenceDataSchema);

const warnRequestSchema = z.object({
  data: CompanyRemunerationReferenceDataSchema.partial(),
  context: CompanyRemunerationReferenceContextSchema,
});

const validateRequestSchema = z.object({
  data: CompanyRemunerationReferenceDataSchema.partial(),
  context: CompanyRemunerationReferenceContextSchema,
});

export type ExtractResponse = z.infer<typeof CompanyRemunerationReferenceExtractionSchema>;
export type WarnRequestBody = z.infer<typeof warnRequestSchema>;
export type WarnResponse = FieldMessages<CompanyRemunerationReferenceData>;
export type ValidateRequestBody = z.infer<typeof validateRequestSchema>;
export type ValidateResponse = FieldMessages<CompanyRemunerationReferenceData>;
export type StoreResponse = z.infer<typeof storeResponseSchema>;

export const CompanyRemunerationReferenceSchemas = {
  extractResponse: CompanyRemunerationReferenceExtractionSchema,
  warnRequest: warnRequestSchema,
  warnResponse: fieldMessagesSchema,
  validateRequest: validateRequestSchema,
  validateResponse: fieldMessagesSchema,
  storeResponse: storeResponseSchema,
} satisfies DocumentTypeSchemas;
